import React from 'react'
import { Link } from 'react-router-dom'
import Paginate from 'components/paginate'
import {Search} from 'components/common'
import {SimpleBanner} from './banner'

/*
export class Newspaper extends React.Component {
	constructor(props) {
		super(props)
		this.state = { news: null }
	}

	componentDidMount() { 
		http.get('home/getNews.json', {id: this.props.match.params.id}, response => {
			this.setState({ news: response.news });
		});
	}

	render() {
		if (this.state.news == null) {
			return null
		}
		const news = this.state.news;
		return (
			<div className="news">
				<SimpleBanner />
				<div className="container">
					<div className="row justify-content-center">
						<div className="col-xs-12 col-md-10">
							<h4>{news.name}</h4>
							<img src={news.img || news.href} alt={news.name}/>
							<div dangerouslySetInnerHTML={{__html: news.body || news.comment}} />
						</div>
					</div>
				</div>
			</div>
		);
	}
}
*/

export default class NewsPage extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			news: [],
			page_count: 24,
			f_search: null
		};
		this.news_all = [];
		this.componentWillReceiveProps(props);
	}

	componentWillReceiveProps(props) {
		this.state.item_id = props.match && props.match.params.nid
			? props.match.params.nid
			: 0;
		if (this.state.item_id) {
			http.get(props.match.params.type == 0 ? '/home/getArticle.json' : '/home/getNews.json', {id: this.state.item_id}, response => {
				this.setState({item: response.news})
			})
		}
		else {
			this.state.item_id = 0;
			this.state.item = null;
		}
	}

	componentDidMount() {
		http.get('home/getNews.json', {}, response => {
			this.setState({ news: response.news });
			response.news.forEach(m => {
				m.search = m.name.normalize().toLowerCase();
			});
			this.news_all = response.news;
		});
	}

	filter(name, value) {
		this.state[name] = value;
		const { f_search } = this.state;
		const news = this.news_all.filter(n => (
			(!f_search || n.search.indexOf(f_search) >= 0)
		));
		this.setState({news: news})
	}

	render() {
		if (this.state.item) {
			const {item} = this.state
			return (
				<div>
					<SimpleBanner title={__('news_index')} />
					<div className="container-fluid">
						<div className="row justify-content-center mt-4">
							<div className="col-sm col-md-8 dyn-content">
								<h5>{item.name || null}</h5>
								<img src={item.img} alt={item.name} />
								<div className="content" dangerouslySetInnerHTML={{__html: item.body}}></div>
							</div>
						</div>
					</div>
				</div>
			)
		}
		if (this.state.item_id) {
			return null;
		}
		return (
			<div className="news">
				<SimpleBanner title={__('news_index')} />
				<div className="container">
					<div className="row mt-4">
						<div className="col">
							<div className="float-right">
								<div className="input-group input-group-sm mb-3">
									<Search doSearch={value => this.filter('f_search', value)} />
								</div>
							</div>
						</div>
					</div>
					<div className="row justify-content-center">
						<Paginate
							items={this.state.news}
							classNameEl="col-xs-12 col-sm-6 col-md-4 pb-4"
							itemsPerPage={this.state.page_count}
							renderItem={news => {
								const img = news.img
									? <img className='img' src={news.img} alt={news.name} />
									: <div className="img" />;
								const body = 
										<div className="name">
											<div className="date">
												{news.day} {news.month_year}
											</div>
											<div>
												{news.name}
											</div>
										</div>
								return (news.href
									? <a href={news.href} key={news.id} target="_blank">{img}{body}</a>
									: <Link to={'/home/news/' + news.id} key={news.id} className="item">{img}{body}</Link>
								)}
							}
							paginationContainer={page_nav =>
								<div key="pc" className="col-sm">
									{page_nav}
								</div>
							}
						/>
					</div>
				</div>
			</div>
		);
	}
}
